import { render, staticRenderFns } from "./SubmissionList.vue?vue&type=template&id=201fcd48&"
import script from "./SubmissionList.vue?vue&type=script&lang=js&"
export * from "./SubmissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports